module.exports = __webpack_public_path__ + "img/txt_series_104.e2446817.png";